import View from './View';

export { default as View, getSettingsWrapperStyles } from './View';

export default View;
